import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

import { ComputedListingOpenNow } from '../../../computed-values';

export function Sort(this: ListingsService, a: Listing, b: Listing): number {
  const _aDate = new Date(a.date).getTime();
  const _bDate = new Date(b.date).getTime();

  switch (this.filteringService.sort()) {
    case 'newest':
      // Newest to oldest.
      return _bDate - _aDate;
    case 'price-high':
      // Price high to low. If the price is the same, sort by date (newest first).
      if (a.price < b.price) {
        return 1;
      }
      if (a.price > b.price) {
        return -1;
      }

      return _bDate - _aDate;
    case 'price-low':
      // Price low to high. If the price is the same, sort by date (newest first).
      if (a.price > b.price) {
        return 1;
      }
      if (a.price < b.price) {
        return -1;
      }

      return _bDate - _aDate;
    default:
      // Group: 0 = open today, 1 = open tomorrow, 2 = neither.
      // eslint-disable-next-line no-case-declarations -- This is a special case where we want to sort by open today/tomorrow first, then by start time, then by date.
      const _groupA = ComputedListingOpenNow(a) ? 0 : a.openTomorrow ? 1 : 2;
      // eslint-disable-next-line no-case-declarations -- This is a special case where we want to sort by open today/tomorrow first, then by start time, then by date.
      const _groupB = ComputedListingOpenNow(b) ? 0 : b.openTomorrow ? 1 : 2;

      if (_groupA !== _groupB) {
        return _groupA - _groupB;
      }

      // Within "open today" group, sort by start time ascending.
      if (_groupA === 0) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- We know that if _groupA is 0, then a.openToday is not null.
        return new Date(a.openToday!.start).getTime() - new Date(b.openToday!.start).getTime();
      }

      // Within "open tomorrow" group, sort by start time ascending.
      if (_groupA === 1) {
        return (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- We know that if _groupA is 1, then a.openTomorrow is not null.
          new Date(a.openTomorrow!.start).getTime() - new Date(b.openTomorrow!.start).getTime()
        );
      }

      if (this.filteringService.ids().length > 0) {
        return (
          this.filteringService.ids().indexOf(a.id || '') -
          this.filteringService.ids().indexOf(b.id || '')
        );
      }

      // if (this.filteringService.ids().length > 0) {
      //   return this.filteringService.ids().indexOf(a.id ?? '') - this.filteringService.ids().indexOf(b.id ?? '');
      // }

      // Everything else: sort by date (earliest to latest).
      return _bDate - _aDate;
  }
}
